<template>
  <div class="tab-page">
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane name="monitoring" v-if="p('Production.Monitoring.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Monitoring
          </div>
          <div class="label-desc">production metrics</div>
        </div>
        <Monitoring v-if="activeName === 'monitoring'" />
      </el-tab-pane>
      <el-tab-pane name="test_reports" v-if="p('Production.Test Reports.View')">
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Test Reports
          </div>
          <div class="label-desc">electrical and functional test report</div>
        </div>
        <TestReports v-if="activeName === 'test_reports'" />
      </el-tab-pane>
      <el-tab-pane
        name="acceptance_criteria"
        v-if="p('Production.Acceptance Criteria.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Acceptance Criteria
          </div>
          <div
            class="label-desc"
            v-html="'electrical and functional acceptance criteria'"
          ></div>
        </div>
        <AcceptanceCriteria v-if="activeName === 'acceptance_criteria'" />
      </el-tab-pane>
      <el-tab-pane
        name="firmware"
        v-if="p('Production.Firmware & Software.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Firmware
          </div>
          <div class="label-desc">firmware and software</div>
        </div>
        <Firmware v-if="activeName === 'firmware'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Monitoring from '@/components/production/pod/Monitoring'
import TestReports from '@/components/production/pod/TestReports'
import AcceptanceCriteria from '@/components/production/pod/AcceptanceCriteria'
import Firmware from '@/components/production/pod/Firmware'
import $ from 'jquery'
export default {
  data() {
    return {
      activeName: 'monitoring',
      screenWidth: 0
    }
  },
  components: {
    Monitoring,
    TestReports,
    AcceptanceCriteria,
    Firmware
  },
  mounted: function() {
    if (this.$permission('Production.Monitoring.View')) {
      this.activeName = 'monitoring'
    } else if (this.$permission('Production.Test Reports.View')) {
      this.activeName = 'test_reports'
    } else if (this.$permission('Production.Acceptance Criteria.View')) {
      this.activeName = 'acceptance_criteria'
    } else {
      this.activeName = 'firmware'
    }
    this.getScreenWidth()
    window.addEventListener('resize', this.getScreenWidth)
    setTimeout(() => {
      this.toggleNavArrow()
      if (this.screenWidth <= 1023) {
        this.listenNavBtnClick()
      }
    }, 50)
  },
  watch: {
    activeName() {
      this.toggleNavArrow()
    }
  },
  methods: {
    listenNavBtnClick() {
      var nextBtn = document.getElementsByClassName('el-tabs__nav-next')
      nextBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-next').hide()
          $('.el-tabs__nav-prev').show()
        },
        true
      )
      var prevBtn = document.getElementsByClassName('el-tabs__nav-prev')
      prevBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-prev').hide()
          $('.el-tabs__nav-next').show()
        },
        true
      )
    },
    toggleNavArrow() {
      if (this.activeName === 'firmware') {
        $('.el-tabs__nav-next').hide()
      } else {
        $('.el-tabs__nav-next').show()
      }
      if (this.activeName === 'monitoring') {
        $('.el-tabs__nav-prev').hide()
      } else {
        $('.el-tabs__nav-prev').show()
      }
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
